<template>
	<div class="shopCar px16 layui-layout layui-layout-admin" style="background:#fff;overflow-y:auto;max-height:100%;" v-show="show">
		<div class="layui-header al_itm" style="background:#fff;">
			<div class="px18 al_itm" style="color:#000;margin-left:20px;">
				<i @click="back" class="layui-icon-left layui-icon px20 pointer" style="margin-right:20px;"></i>订单详情
			</div>
		</div>
		<div>
			<div class="f_col px16 status" style="padding:20px 30px;line-height: 50px;">
				<p>订单编号 <span>{{order_info.order_num}}</span></p>
				<p>订单金额 <span>{{order_info.price}}元</span></p>

				<p v-if="order_info.status != 4 && order_info.add_price > 0 ">尾款金额：{{order_info.add_price}}元
					<el-popover placement="right" title="尾款说明" width="200" trigger="click">
						<div>由于该订单设计开孔过多，需要额外加收{{order_info.add_price}}元尾款</div>
						<span style="color: rgba(72, 118, 255, 1);cursor: pointer;" slot="reference">【尾款说明】</span>
					</el-popover>
				</p>

				<p>订单状态
					<span id="status1" class="status_text" v-if="order_info.status == 3 && order_info.sales_status == 1">工程师返工</span>
					<span id="status1" class="status_text" v-else-if="order_info.status == 6 && order_info.sales_status == 2">工厂返工</span>
					<span :id="'status'+order_info.status" class="status_text" v-else>{{order_info.status_text}}</span>
					<span class="layui-btn layui-btn-radius layui-btn-sm cancel" v-if="order_info.status == 1" @click="cancelOrder">取消订单</span>

					<span class="layui-btn layui-btn-radius layui-btn-sm add_price" v-if="order_info.status == 4 && order_info.add_price > 0 && order_info.add_status != 2 && userInfo.pay_type != 2" @click="addPrice(0)">支付尾款</span>
					<span class="layui-btn layui-btn-radius layui-btn-sm add_price" v-if="order_info.status == 4 && order_info.add_price > 0 && order_info.add_status != 2 && userInfo.pay_type == 2" @click="addPrice(1)">微信支付尾款</span>
					<span class="layui-btn layui-btn-radius layui-btn-sm add_price" v-if="order_info.status == 4 && order_info.add_price > 0 && order_info.add_status != 2 && userInfo.pay_type == 2" @click="addPrice(2)">支付宝支付尾款</span>

					<span v-if="order_info.status == 4 && order_info.add_price > 0 && order_info.add_status != 2">尾款金额：{{order_info.add_price}}元
						<el-popover placement="right" title="尾款说明" width="200" trigger="click">
							<div>由于该订单设计开孔过多，需要额外加收{{order_info.add_price}}元尾款</div>
							<span style="color: rgba(72, 118, 255, 1);cursor: pointer;" slot="reference">【尾款说明】</span>
					</el-popover>
					</span>

					<span class="layui-btn layui-btn-radius layui-btn-sm delivery" v-if="order_info.status == 7 && order_info.sales_status == 0" @click="finishOrder(1)">确认收货</span>
					<span class="layui-btn layui-btn-radius layui-btn-sm delivery" v-if="order_info.status == 7 && order_info.sales_status != 0" @click="finishOrder(2)">售后完成</span>
					<span class="layui-btn layui-btn-radius layui-btn-sm afterSale" v-if="order_info.status == 7 && timeline.is_after_sales != 1" @click="afterSale">发起售后</span>
					<span class="layui-btn layui-btn-radius layui-btn-sm afterSale" v-if="order_info.status == 10" @click="onEvaluate">评价</span>
				</p>
				<p>下单时间 <span>{{order_info.time}}</span></p>
				<p v-if="finish_time && order_info.status != 1 && order_info.status != 15">
					到货时间 <span>预计 {{finish_time}} 到货</span>
					<span class="layui-btn layui-btn-radius layui-btn-sm delivery" @click="onLogistics(1)" v-if='order_info.status >= 7 && order_info.status != 15 && express_id.company !="自提" && express_id.company !="自配送"'>查看物流</span>
					<span class="layui-btn layui-btn-radius layui-btn-sm delivery-false" v-else>查看物流</span>
				</p>
			</div>
			<div v-if="order_info.status && order_info.status != 1" class="progress">
				<div class="zt_color title">订单进度</div>
				<ul class="layui-timeline" style="padding:20px 30px;">
					<li class="layui-timeline-item" v-for="(item,i) in order_progress">
						<i class="layui-icon layui-timeline-axis zt_txt_color px20">&#xe617;</i>
						<div class="layui-timeline-content layui-text">
							<div class="layui-timeline-title" style="display: flex;">
								<div class="px16">{{item.title}}</div>
								<div class="px14 margin_l10">{{item.time_txt}}</div>
								<div v-if='i == 1 && order_info.status != 15 && order_info.status != 10 && order_info.status != 11 && order_info.is_mine == 1' @click="onGouTong" class="px16 zt_txt_color margin_l10 pointer goutong"><i class="layui-icon">&#xe611;</i>&nbsp;&nbsp;沟通</div>
								<div v-if='i == 1 && order_info.status != 15 && order_info.status != 10 && order_info.status != 11 && order_info.is_mine == 0' class="px16 margin_l10 goutong2"><i class="layui-icon">&#xe611;</i>&nbsp;&nbsp;沟通</div>
								<div v-if='i == 2 && is_c_confirm != 2 && order_info.sales_status != 1' @click="confirmOrder" class="layui-btn layui-btn-radius layui-btn-sm btn1" style="margin: -5px 0 0 15px;">确认完成</div>
								<div v-if="item.title == '工程师返工完成' && is_c_confirm != 2" @click="confirmOrder" class="layui-btn layui-btn-radius layui-btn-sm btn1" style="margin: -5px 0 0 15px;">确认完成</div>
								<div v-if="item.title == '已发货'" style="margin-left: 15px;">
									<span>{{express_info.express_name}}</span><span class="links" style="margin-left: 15px;">{{express_info.express_num}}</span>
								</div>
								<div v-if="item.title == '补发'" style="margin-left: 15px;">
									<span>{{express_info.rep_express_name}}</span><span class="links" style="margin-left: 15px;">{{express_info.rep_express_num}}</span>
									<span class="layui-btn layui-btn-radius layui-btn-sm delivery" style="margin-left: 15px;" @click="onLogistics(2)">查看物流</span>
								</div>
								<div v-if="item.title == '工厂重新发货' && express_info.sale_express_name" style="margin-left: 15px;">
									<span>{{express_info.sale_express_name}}</span><span class="links" style="margin-left: 15px;">{{express_info.sale_express_num}}</span>
									<span class="layui-btn layui-btn-radius layui-btn-sm delivery" style="margin-left: 15px;" @click="onLogistics(3)">查看物流</span>
								</div>
							</div>
							<div class="file-list">
								<div class="file-item" v-if="i == 2 && is_c_confirm != 0  && order_info.sales_status != 1 && pdf.e_update_file" v-for='(pdf,j) in other_make'>
									<a class="links" :href="pdf.e_update_file" v-if="pdf.e_update_file_status < 3" target="_blank">工程文件{{j+1}}完成版.pdf</a>
									<a class="links" style="color: #E2E2E2;" v-if="pdf.e_update_file_status == 3">工程文件{{j+1}}完成版.pdf</a>
									<a class="links" :href="pdf.e_update_file" v-if="pdf.e_update_file_status == 4" target="_blank">工程文件{{j+1}}修改版.pdf</a>
									<div class="btn2 layui-btn layui-btn-radius layui-btn-sm" v-if="pdf.e_update_file_status == 1 || pdf.e_update_file_status == 4" @click="confirmPDF(pdf.order_attr_id)">确认无误</div>
									<div class="btn3 layui-btn layui-btn-radius layui-btn-sm" v-if="pdf.e_update_file_status == 3">工程师返工中</div>
									<p v-if="pdf.e_update_file_status == 3 || pdf.e_update_file_status == 4" style="max-width: 70%;">原因：{{pdf.reason}}</p>
								</div>
								<div class="file-item" v-if="item.title == '工程师返工完成' && is_c_confirm != 0 && pdf.e_update_file" v-for='(pdf,j) in other_make'>
									<a class="links" :href="pdf.e_update_file" v-if="pdf.e_update_file_status < 3" target="_blank">工程文件{{j+1}}完成版.pdf</a>
									<a class="links" style="color: #E2E2E2;" v-if="pdf.e_update_file_status == 3">工程文件{{j+1}}完成版.pdf</a>
									<a class="links" :href="pdf.e_update_file" v-if="pdf.e_update_file_status == 4" target="_blank">工程文件{{j+1}}修改版.pdf</a>
									<div class="btn2 layui-btn layui-btn-radius layui-btn-sm" v-if="pdf.e_update_file_status == 1 || pdf.e_update_file_status == 4" @click="confirmPDF(pdf.order_attr_id)">确认无误</div>
									<div class="btn3 layui-btn layui-btn-radius layui-btn-sm" v-if="pdf.e_update_file_status == 3">工程师返工中</div>
									<p v-if="pdf.e_update_file_status == 3 || pdf.e_update_file_status == 4" style="max-width: 70%;">原因：{{pdf.reason}}</p>
								</div>
							</div>
						</div>
					</li>
					<li class="layui-timeline-item false" v-for="(item,i) in estimate">
						<i class="layui-icon layui-timeline-axis zt_txt_color px20">&#xe617;</i>
						<div class="layui-timeline-content layui-text">
							<div class="layui-timeline-title" style="display: flex;">
								<div class="px16">{{item.title}}</div>
								<div class="px14 margin_l10">{{item.time_txt}}</div>
								<div class="count_down" v-if='i == 0 && !overtime && count_down'><i class="layui-icon layui-icon-log"></i><span>{{count_down}}</span></div>
								<div class="count_down" v-if='i == 0 && overtime'><span style="color: #FF0000;">超时</span></div>
							</div>
							<div class="file-list"></div>
						</div>
					</li>
				</ul>
			</div>
			<div v-if='mesh_attr!=[] && mesh_attr[0]'>
				<div class="zt_color title">钢网规格</div>
				<table class="layui-table align_center orBoxs">
					<colgroup>
						<col width="200">
						<col>
						<col>
						<col>
						<col>
						<col>
					</colgroup>
					<thead>
						<tr class="white">
							<th class="align_center">序号</th>
							<th class="align_center">钢片规格</th>
							<th class="align_center">钢片有效印刷面积</th>
							<th class="align_center">单价</th>
							<th class="align_center">数量</th>
							<th class="align_center">其他产品</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,i) in mesh_attr" :key="i">
							<td>{{i+1}}</td>
							<td>{{item.attr_title}}</td>
							<td>{{item.use_title}}</td>
							<td>{{parseFloat(item.money)+parseFloat(userInfo.pay_type_price)}}</td>
							<td>{{craft_demand[i].buy_num}}</td>
							<td>{{other_product[i].other_product_text}}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div>
				<div class="zt_color title">工艺要求</div>
				<table class="layui-table align_center orBoxs">
					<thead>
						<tr class="white">
							<th class="align_center">序号</th>
							<th class="align_center">制作要求</th>
							<th class="align_center">交付类型</th>
							<th class="align_center">激光打标</th>
							<th class="align_center">钢网工艺</th>
							<th class="align_center">制作工艺</th>
							<th class="align_center">钢片厚度</th>
							<th class="align_center">Mark基准点</th>
							<th class="align_center">排版方式</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,i) in craft_demand" :key="i">
							<td>{{i+1}}</td>
							<td>{{item.make_demand_text}}</td>
							<td>{{item.is_fast_text}}</td>
							<td>{{item.laser_marking_text}}</td>
							<td>{{item.mesh_purpose_text}}</td>
							<td>{{item.mark_craft_text}}</td>
							<td>{{item.thick_num_text}}</td>
							<td>{{item.mark_point_text}}</td>
							<td>{{item.compose_type_text}}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div>
				<div class="zt_color title">CHIP开孔要求</div>
				<table class="layui-table align_center orBoxs">
					<colgroup>
						<col width="200">
						<col>
						<col>
						<col>
						<col>
					</colgroup>
					<thead>
						<tr class="white">
							<th class="align_center">序号</th>
							<th class="align_center">开孔工艺</th>
							<th class="align_center">开孔类型</th>
							<th class="align_center">开孔方案</th>
							<th class="align_center">防锡珠类型</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,i) in open_demand" :key="i">
							<td>{{i+1}}</td>
							<td>{{item.mesh_type == 1 ? '锡膏工艺' : '红胶工艺'}}</td>
							<td>{{item.mesh_type == 2 ? '' : item.hole}}</td>
							<td class="align_center">{{item.solder_hole_size_text}}</td>
							<td>{{item.hole_type}}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div v-if="hideICBGAPAD">
				<div class="zt_color title">IC集成电路开孔要求</div>
				<table class="layui-table align_center orBoxs">
					<colgroup>
						<col width="200">
						<col>
						<col>
						<col>
					</colgroup>
					<thead>
						<tr class="white">
							<th class="align_center">序号</th>
							<th class="align_center">开孔方案</th>
							<th class="align_center">开孔宽度</th>
							<th class="align_center">开孔形状</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,i) in craft_demand" :key="i" v-if="open_demand[i].mesh_type == 1">
							<td>{{i+1}}</td>
							<td>{{item.ic_open_ask_text}}</td>
							<td>{{item.ic_open_ask_size_text}}</td>
							<td>{{item.ic_open_shape_text}}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div v-if="hideICBGAPAD">
				<div class="zt_color title">BGA封装开孔要求</div>
				<table class="layui-table align_center orBoxs">
					<colgroup>
						<col width="200">
						<col>
						<col>
						<col>
					</colgroup>
					<thead>
						<tr class="white">
							<th class="align_center">序号</th>
							<th class="align_center">开孔方案</th>
							<th class="align_center">开孔直径</th>
							<th class="align_center">开孔形状</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,i) in craft_demand" :key="i" v-if="open_demand[i].mesh_type == 1">
							<td>{{i+1}}</td>
							<td>{{item.bga_open_ask_text}}</td>
							<td>{{item.bga_open_ask_size_text}}</td>
							<td>{{item.bga_open_shape_text}}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div v-if="hideICBGAPAD">
				<div class="zt_color title">散热PAD</div>
				<table class="layui-table align_center orBoxs">
					<colgroup>
						<col width="200">
						<col>
						<col>
					</colgroup>
					<thead>
						<tr class="white">
							<th class="align_center">序号</th>
							<th class="align_center">开孔形状</th>
							<th class="align_center">开孔面积</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,i) in craft_demand" :key="i" v-if="open_demand[i].mesh_type == 1">
							<td>{{i + 1}}</td>
							<td>{{item.pad_open_shape_text}}</td>
							<td>{{item.pad_open_area_text}}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div>
				<div class="zt_color title">其他制作要求和工程文件</div>
				<table class="layui-table align_center orBoxs">
					<colgroup>
						<col width="200">
						<col width="300">
						<col>
					</colgroup>
					<thead>
						<tr class="white">
							<th class="align_center">序号</th>
							<th class="align_center">工程文件</th>
							<th class="align_center">其他要求说明</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,i) in other_make" :key="i">
							<td>{{i+1}}</td>
							<td class="d_line pointer zt_txt_color">
								<a :href="item.pdf_file" style="color: rgb(72, 118, 255);">工程文件</a>
								<a :href="item.pdf_file" class="downloadBtn" v-if="item.e_pdf_file">下载</a>
							</td>
							<td>{{item.message ? item.message : '无'}}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div v-if="false">
				<div class="zt_color title">发票信息</div>
				<div class="courier">
					开票信息： <span>需要</span>
				</div>
				<div class="courier">
					是否需要送货单及收据 ：<span>需要</span>
				</div>
				<div class="courier">
					收据抬头 ：<span>123456</span>
				</div>
			</div>
			<div v-if="take_info">
				<div class="zt_color title">收货地址&订单联系人</div>
				<table class="layui-table orBoxs">
					<colgroup>
						<col width="50%">
						<col width="50%">
					</colgroup>
					<tbody>
						<tr>
							<td>
								<div class="address">
									<div class="msg">
										<div class="msg-top">{{take_info.take_name}}，{{take_info.take_mobile}}</div>
										<div class="msg-bottom">{{take_info.take_province}}{{take_info.take_city}}{{take_info.take_area}}{{take_info.take_address}}</div>
									</div>
								</div>
							</td>
							<td>
								<div class="linkman">
									<div class="msg">
										<div class="msg-top">{{take_info.contact_name}}，{{take_info.contact_mobile}}</div>
									</div>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div v-if="express_id">
				<div class="zt_color title">快递信息</div>
				<div class="courier">
					选择快递 <span>{{express_id.company}}</span>
				</div>
				<div class="courier">
					配送费用<span>{{order_info.express_price}}元</span>
				</div>
			</div>
			<div v-if="order_info.status == 1 && userInfo != ''">
				<div class="zt_color title">订单合计</div>
				<div class="courier">
					订单金额： <span>{{order_info.price}}元</span>
				</div>
				<div class="courier" v-if="userInfo.pay_type == 1">
					账户桃币：<span>{{userInfo.score}}</span>
				</div>
			</div>
			<div class="f_row al_itm" style="padding: 12px 12px 30px 30px;font-size: 18px;" v-if="userInfo.pay_type == 2 && order_info.status == 1">
				<div style="margin-right:20px;min-width:70px;">支付方式：</div>
				<div @click="setPayclass(1)" style="margin-right:40px;" class="f_row al_itm pointer px16">
					<i v-show="pay_type == 1" class="layui-icon-radio layui-icon px20 zt_txt_color"></i>
					<i v-show="pay_type != 1" class="layui-icon-circle layui-icon px20 zt_txt_color"></i>
					<img class="icons" src="../assets/wchat.png" height="28" width="28" alt="" style="margin: 0 10px;">
					<span>微信支付</span>
				</div>
				<div @click="setPayclass(2)" class="f_row al_itm pointer px16">
					<i v-show="pay_type == 2" class="layui-icon-radio layui-icon px20 zt_txt_color"></i>
					<i v-show="pay_type != 2" class="layui-icon-circle layui-icon px20 zt_txt_color"></i>
					<img class="icons" src="../assets/aply.png" height="28" width="28" alt="" style="margin: 0 10px;">
					<span>支付宝支付</span>
				</div>
			</div>
		</div>
		<button class="pay" @click="onPay" v-if="order_info.status == 1">确认支付</button>

		<!--弹出层-->
		<div class="layer" v-if='edit'></div>
		<div id="qrCode" style="display: none;">
			<img :src="'https://mr.summary88.com/'+imgUrl" />
			<p>请打开微信扫码支付</p>
		</div>
		<div id="appeal" style="display: none;">
			<h3 class="title">反馈问题</h3>
			<textarea maxlength="120" placeholder="请输入设计图上的问题" v-model="text1"></textarea>
		</div>
		<div id="after" style="display: none;">
			<h3 class="title">售后</h3>
			<div class="layui-form" lay-filter='formTest'>
				<div class="layui-form-item">
					<p>是否遇到下列所属问题？</p>
					<div class="checkbox_box">
						<input class="checkbox" type="radio" name="radios" lay-verify="required" :title="item.title" :value="item.id" lay-skin="primary" v-for="(item,i) in category">
					</div>
				</div>
				<div class="layui-form-item">
					<textarea maxlength="200" placeholder="请输入您遇到的问题，多钢网的情况下请填上出现问题的钢网的序号" name="content" lay-reqText="请输入您遇到的问题" lay-verify="required"></textarea>
				</div>
				<div class="layui-form-item">
					<img class="preview" v-for="item in img" :src="item" />
					<img class="upload_img pointer" src="../assets/add-img.png" v-if="img.length != 1" />
				</div>
				<div class="layui-form-item f_row jc_ct">
					<button class="layui-btn zt_color" style="border-radius: 5px;" lay-submit lay-filter="submit">确认提交</button>
				</div>
			</div>
		</div>
		<div id="evaluate" style="display: none;">
			<h3 class="title">评价</h3>
			<div class="layui-form" lay-filter='formTest2'>
				<div class="layui-form-item" style="width: 100%;">
					<h3>订单综合评分</h3>
					<div class="star_total">
						<div class="label">综合评分：</div>
						<div id="star1"></div>
					</div>
				</div>
				<div class="layui-form-item">
					<h3>工程师评分</h3>
					<div class="star_box">
						<div class="star_list">
							<div class="label">服务态度：</div>
							<div id="star2"></div>
						</div>
						<div class="star_list">
							<div class="label">工作速度：</div>
							<div id="star3"></div>
						</div>
						<div class="star_list">
							<div class="label">满意度：</div>
							<div id="star4"></div>
						</div>
					</div>
				</div>
				<div class="layui-form-item">
					<h3>工厂评分</h3>
					<div class="star_box">
						<div class="star_list">
							<div class="label">服务态度：</div>
							<div id="star5"></div>
						</div>
						<div class="star_list">
							<div class="label">工作速度：</div>
							<div id="star6"></div>
						</div>
						<div class="star_list">
							<div class="label">满意度：</div>
							<div id="star7"></div>
						</div>
					</div>
				</div>
				<div class="layui-form-item">
					<h3>物流评分</h3>
					<div class="star_box">
						<div class="star_list">
							<div class="label">服务态度：</div>
							<div id="star8"></div>
						</div>
						<div class="star_list">
							<div class="label">送货速度：</div>
							<div id="star9"></div>
						</div>
						<div class="star_list">
							<div class="label">包装完整度：</div>
							<div id="star10"></div>
						</div>
					</div>
				</div>
				<div class="layui-form-item" style="width: 100%;">
					<p class="tit">评价内容</p>
					<textarea maxlength="120" placeholder="请输入评价内容" name="content" lay-reqText="请输入评价内容" lay-verify="required"></textarea>
				</div>
				<div class="layui-form-item" style="width: 100%;">
					<p class="tit">上传图片</p>
					<div class="preview_box" v-for="(item,i) in img2">
						<img class='cancel_btn' src="../assets/cancel@2x.png" @click="onCancelImage(i)" />
						<img class="preview2" :src="item" />
					</div>
					<img class="upload_img2 pointer" src="../assets/add-img.png" v-if="img2.length <= 8" />
				</div>
				<div class="layui-form-item f_row jc_ct" style="width: 100%;">
					<button class="layui-btn zt_color" lay-submit lay-filter="submit2">提交评价</button>
				</div>
			</div>
		</div>

		<el-dialog title="物流信息" :visible.sync="wuliushow" :append-to-body='true'>
			<el-steps direction="vertical" :active="0" space="60px">
				<el-step v-for="(item,i) in wuliu" :key='i' :title="item.site" :description="item.description + ' ' + item.time" :status="i == 0 ? 'success' : 'wait'" icon='el-icon-circle-check'></el-step>
			</el-steps>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'shopCar',
		data() {
			return {
				ct: '',
				count_down: '', //倒计时
				overtime: 0, //判断是否超时
				userInfo: '',
				show: false,
				progress: true, //控制进度模块是否显示
				is_c_confirm: 0,
				order_num: 0,
				table: '',
				forms: '',
				layers: '',
				uploads: '',
				rate: '',
				finish_time: '', //预计到货时间
				order_info: [], //订单状态信息
				order_progress: [], //进度信息
				estimate: [], //进度信息-预估
				mesh_attr: [], //规格信息
				take_info: [], //联系人信息
				express_info: [], //物流信息
				express_id: '', //选择的快递信息
				craft_demand: [], //工艺要求
				open_demand: [], //开孔要求
				other_make: [], //其他工程文件
				other_product: [], //其他产品
				timeline: '',
				edit: false,
				text1: '',
				img: [],
				img2: [],
				star: [], //评分星星的数组
				category: '', //售后问题分类
				wuliu: [], //物流轨迹
				wuliushow: false,
				hideICBGAPAD: true,
				pay: true,
				clear: '',
				imgUrl: '', //二维码url
				pay_type: 1,
			}
		},
		created() {

		},
		destroyed: function() {　　　
			clearInterval(this.ct);
		},
		mounted() {
			let _this = this;
			let order_num = this.$route.query.id;
			this.order_num = order_num;
			layui.use(['table', 'form', 'layer', 'upload', 'rate'], () => {
				this.table = layui.table;
				this.forms = layui.form;
				this.layers = layui.layer;
				this.uploads = layui.upload;
				this.rate = layui.rate;
				this.forms.render();
				if(order_num) {
					this.getData(order_num);
					this.getSaleCateGory();
				} else {
					this.$router.replace({
						path: '/myOrder'
					})
				}
				this.onRateInit();
				this.forms.on('submit(submit)', function(data) {
					if(!data.field.radios) {
						layer.msg('请选择问题类型', {
							icon: 2,
							anim: 6
						})
						return false;
					}
					api.postSale({
						token: _this.getCookie('token'),
						order_num: _this.order_num,
						question_id: data.field.radios,
						question_desc: data.field.content,
						question_img: _this.img[0] ? _this.img[0] : '',
					}).then((res) => {
						if(res.code == 1) {
							_this.edit = false;
							layer.closeAll();
							layer.msg('提交成功', {
								icon: 1,
								anim: 5
							})
							_this.edit = false;
							layer.closeAll();
							_this.getData(_this.order_num);
						} else {
							layer.msg(res.msg, {
								icon: 2,
								anim: 6
							})
						}
					})
				});
				this.forms.on('submit(submit2)', function(data) {
					if(_this.star[0] == undefined) {
						layer.msg('请选择订单综合评分', {
							icon: 2,
							anim: 6
						})
						return false;
					} else if(_this.star[1] == undefined) {
						layer.msg('请选择工程师服务态度评分', {
							icon: 2,
							anim: 6
						})
						return false;
					} else if(_this.star[2] == undefined) {
						layer.msg('请选择工程师工作速度评分', {
							icon: 2,
							anim: 6
						})
						return false;
					} else if(_this.star[3] == undefined) {
						layer.msg('请选择工程师满意度评分', {
							icon: 2,
							anim: 6
						})
						return false;
					} else if(_this.star[4] == undefined) {
						layer.msg('请选择工厂服务态度评分', {
							icon: 2,
							anim: 6
						})
						return false;
					} else if(_this.star[5] == undefined) {
						layer.msg('请选择工厂工作速度评分', {
							icon: 2,
							anim: 6
						})
						return false;
					} else if(_this.star[6] == undefined) {
						layer.msg('请选择工厂满意度评分', {
							icon: 2,
							anim: 6
						})
						return false;
					} else if(_this.star[7] == undefined) {
						layer.msg('请选择物流服务态度评分', {
							icon: 2,
							anim: 6
						})
						return false;
					} else if(_this.star[8] == undefined) {
						layer.msg('请选择物流送货速度评分', {
							icon: 2,
							anim: 6
						})
						return false;
					} else if(_this.star[9] == undefined) {
						layer.msg('请选择物流包装完整度评分', {
							icon: 2,
							anim: 6
						})
						return false;
					}
					api.addOrderEvaluate({
						token: _this.getCookie('token'),
						order_num: _this.order_num,
						content: data.field.content,
						imgs: _this.img2.join(','),
						order_score: _this.star[0],
						e_service_score: _this.star[1],
						e_speed_score: _this.star[2],
						e_score: _this.star[3],
						f_service_score: _this.star[4],
						f_speed_score: _this.star[5],
						f_score: _this.star[6],
						exp_service_score: _this.star[7],
						exp_speed_score: _this.star[8],
						exp_score: _this.star[9],
					}).then((res) => {
						if(res.code == 1) {
							_this.edit = false;
							layer.closeAll();
							layer.msg('评价成功', {
								icon: 1,
								anim: 5
							})
							_this.getData(_this.order_num);
						} else {
							layer.msg(res.msg, {
								icon: 2,
								anim: 6
							})
						}
					})
				});
			});
		},
		methods: {
			setPayclass(num) {
				this.pay_type = num;
			},
			//返回我的订
			back() {
				this.$router.replace({
					path: '/myOrder'
				})
			},
			// 查询物流信息
			onLogistics(i) {
				let _this = this;
				let name;
				let num;
				if(i == 1) {
					name = this.express_info.express_name;
					num = this.express_info.express_mailno;
				} else if(i == 2) {
					name = this.express_info.rep_express_name;
					num = this.express_info.rep_express_mailno;
				} else {
					name = this.express_info.sale_express_name;
					num = this.express_info.sale_express_mailno;
				}
				if(name == '顺丰速运') {
					api.shunfeng({
						express_num: num,
					}).then((res) => {
						if(res.code == 1) {
							let arr = res.data.Body.RouteResponse.Routes.attributes;
							let wuliu = [];
							arr.forEach((val, index) => {
								let obj = {
									description: val.remark,
									time: val.accept_time,
									site: val.accept_address
								}
								wuliu.push(obj);
							})
							_this.wuliu = wuliu;
							_this.wuliushow = true;
						} else {
							layer.msg(res.msg, {
								icon: 2,
								anim: 6
							})
						}
					})
				} else if(name == '德邦快递') {
					api.debang({
						mailNo: num
					}).then((res) => {
						if(res.code == 1) {
							res.data = JSON.parse(res.data);
							_this.wuliu = res.data.responseParam.trace_list;
							_this.wuliushow = true;
						} else {
							layer.msg(res.msg, {
								icon: 2,
								anim: 6
							})
						}
					})
				} else if(name == '京广速递') {
					api.jg_query({
						mailNo: num
					}).then((res) => {
						if(res.code == 1) {
							if(res.data.data.length == 0) {
								layer.msg('下单成功，等待快递员上门揽收', {
									icon: 1,
									anim: 6
								})
								return false;
							}
							let datas = res.data.data[1].data;
							let wuliu = [];
							datas.forEach((val, index) => {
								let obj = {
									description: val.scanType + ' ' + val.scanMan + val.scanSite,
									time: val.scanDate,
									site: val.content
								}
								wuliu.push(obj);
							})
							_this.wuliu = wuliu;
							_this.wuliushow = true;
						} else {
							layer.msg(res.msg, {
								icon: 2,
								anim: 6
							})
						}
					})
				} else if(name == '信丰物流') {
					if(num) {
						api.xf_query({
							mailNo: num
						}).then((res) => {
							if(res.code == 1) {
								let datas = JSON.parse(res.data);
								let arr = datas.tracesList[0].traces;
								arr = arr.reverse();
								let wuliu = [];
								arr.forEach((val, index) => {
									let obj = {
										description: val.city,
										time: val.time,
										site: val.desc
									}
									wuliu.push(obj);
								})
								_this.wuliu = wuliu;
								_this.wuliushow = true;
							} else {
								layer.msg(res.msg, {
									icon: 2,
									anim: 6
								})
							}
						})
					} else {
						layer.msg('下单成功，等待快递员上门揽收', {
							icon: 1,
							anim: 6
						})
					}
				} else if(name == '京东快递') {
					api.jd_query({
						mailNo: num
					}).then((res) => {
						if(res.code == 1) {
							let arr = res.data.jingdong_ldop_receive_trace_get_responce.querytrace_result.data;
							arr = arr.reverse();
							let wuliu = [];
							arr.forEach((val, index) => {
								let obj = {
									description: val.opeRemark,
									time: val.opeTime,
									site: val.opeTitle
								}
								wuliu.push(obj);
							})
							_this.wuliu = wuliu;
							_this.wuliushow = true;
						} else {
							layer.msg(res.msg, {
								icon: 2,
								anim: 6
							})
						}
					})
				}
			},
			getData(order_num) {
				let _this = this;
				api.getOrderDetail({
					token: this.getCookie('token'),
					order_num: order_num,
					type: 1,
				}).then((res) => {
					if(res.code == 1) {
						_this.order_info = res.data.order_info;
						_this.order_info.time = _this.getTimes(res.data.order_info.createtime);
						_this.mesh_attr = res.data.mesh_attr;
						_this.take_info = res.data.take_info;
						_this.express_info = res.data.express_info || [];
						_this.express_id = res.data.express_id;
						_this.craft_demand = res.data.craft_demand;
						_this.open_demand = res.data.open_demand;
						_this.other_make = res.data.other_make;
						_this.timeline = res.data.order_progress;
						_this.other_product = res.data.other_product;
						_this.finish_time = _this.getTimes2(res.data.order_info.express_finish_time);
						_this.is_c_confirm = res.data.order_progress.is_c_confirm; //判断是否有设计有误的文件存在
						_this.getOrderProgress(_this.order_num, res.data.order_info.status);
						_this.onHide();
						_this.getUserInfo();
					} else {
						layer.msg(res.msg, {
							icon: 2,
							anim: 6
						})
					}
				})
			},
			onHide() {
				if(this.open_demand.length == 1 && this.open_demand[0].mesh_type == 2) {
					this.hideICBGAPAD = false;
				} else if(this.open_demand.length > 1) {
					let hide = false;
					for(let i = 0; i < this.open_demand.length; i++) {
						if(this.open_demand[i].mesh_type == 1) {
							hide = true;
						}
					}
					this.hideICBGAPAD = hide;
				}
			},
			getOrderProgress(order_num, status) {
				let _this = this;
				api.getOrderProgress({ //工程师完成订单
					token: _this.getCookie('token'),
					order_num: _this.order_info.order_num,
					type: 1
				}).then((res) => {
					if(res.code == 1) {
						_this.orderProgress(res.data, status);
					} else {
						layer.msg(res.msg, {
							icon: 2,
							anim: 6
						})
					}
				})
			},
			getUserInfo() {
				let _this = this;
				api.getMemberInfo({ //获取会员信息
					token: this.getCookie('token')
				}).then((res) => {
					if(res.code == 1) {
						_this.show = true;
						_this.userInfo = res.data;
					} else if(res.code == 0) {
						layer.msg(res.msg, {
							icon: 2,
							anim: 6
						})
					}
				});
			},
			onPay() {
				let _this = this;
				let price = this.order_info.price;
				layui.use('layer', () => {
					let layer = layui.layer;
					layer.open({
						type: 0,
						title: '确认支付',
						content: `订单金额${price}元`,
						btn: ['确认支付', '取消'],
						btnAlign: 'c',
						resize: false,
						closeBtn: 0,
						skin: 'demo-class',
						yes: function(index, layero) {
							layer.closeAll();
							if(_this.userInfo.pay_type == 2) {
								layer.msg('加载中', {
									icon: 16,
									shade: 0.01,
								});
								api.getOrderPay({
									token: _this.getCookie('token'),
									order_num: _this.order_num,
									order_type: 1,
									pay_type: _this.pay_type
								}).then((res1) => {
									if(_this.pay_type == 1) {
										if(res1.code == 1) {
											_this.imgUrl = res1.data;
											layer.closeAll();
											layer.open({
												title: '支付',
												type: 1,
												resize: false,
												content: $('#qrCode'),
												success: function() {
													_this.verify(_this.order_num, 1);
												},
												cancel: function() {
													layer.closeAll();
													clearInterval(_this.clear);
												}
											});
										} else {
											layer.msg(res1.msg, {
												icon: 2,
												anim: 6
											})
										}
									} else {
										layer.closeAll();
										let divForm = document.getElementsByTagName('divform')
										if(divForm.length) {
											document.body.removeChild(divForm[0])
										}
										const div = document.createElement('divform');
										div.innerHTML = res1; // data就是接口返回的form 表单字符串
										document.body.appendChild(div);
										document.forms[0].submit();
									}
								})
							} else {
								api.payOrder({
									token: _this.getCookie('token'),
									order_num: _this.order_num,
								}).then((res) => {
									if(res.code == 1) {
										_this.$router.replace({
											path: '/paysuccess',
											query: {
												id: _this.order_num
											}
										})
									} else {
										layer.msg(res.msg, {
											icon: 2,
											anim: 6
										})
									}
								})
							}
						},
						btn2: function(index, layero) {
							layer.closeAll();
						}
					});
				})
			},
			addPrice(type) { //支付尾款
				let _this = this;
				layui.use('layer', () => {
					layer.open({
						type: 0,
						content: '是否确认支付订单尾款？',
						btn: ['确定', '取消'],
						btnAlign: 'c',
						resize: false,
						closeBtn: 0,
						skin: 'demo-class',
						yes: function(index, layero) {
							layer.closeAll();
							layer.msg('加载中', {
								icon: 16,
								shade: 0.01,
							});
							if(_this.userInfo.pay_type == 2) {
								api.getOrderPay({
									token: _this.getCookie('token'),
									order_num: _this.order_num,
									order_type: 3,
									pay_type: type ? type : 1
								}).then((res1) => {
									if(type == 1) {
										if(res1.code == 1) {
											_this.imgUrl = res1.data;
											layer.closeAll();
											layer.open({
												title: '支付',
												type: 1,
												resize: false,
												content: $('#qrCode'),
												success: function() {
													_this.verify(_this.order_num, 3);
												},
												cancel: function() {
													layer.closeAll();
													clearInterval(_this.clear);
												}
											});
										} else {
											layer.msg(res1.msg, {
												icon: 2,
												anim: 6
											})
										}
									} else {
										layer.closeAll();
										let divForm = document.getElementsByTagName('divform')
										if(divForm.length) {
											document.body.removeChild(divForm[0])
										}
										const div = document.createElement('divform');
										div.innerHTML = res1; // data就是接口返回的form 表单字符串
										document.body.appendChild(div);
										document.forms[0].submit();
									}
								})
							} else {
								api.payAddPrice({
									token: _this.getCookie('token'),
									order_num: _this.order_info.order_num,
								}).then((res) => {
									if(res.code == 1) {
										layer.msg('支付尾款成功', {
											icon: 1,
											anim: 5
										})
										api.confirmOrder({
											token: _this.getCookie('token'),
											order_num: _this.order_info.order_num
										}).then((res) => {
											if(res.code == 1) {
												_this.getData(_this.order_info.order_num);
											} else {
												layer.msg(res.msg, {
													icon: 2,
													anim: 6
												})
											}
										})
									} else {
										layer.msg(res.msg, {
											icon: 2,
											anim: 6
										})
									}
								})
							}
						},
						btn2: function(index, layero) {
							layer.closeAll();
						}
					});
				})
			},
			verify(num, type) {
				var _this = this;
				var i = 0;
				clearInterval(_this.clear);
				_this.clear = setInterval(() => {
					i++;
					api.checkPayStatus({
						token: this.getCookie('token'),
						order_type: type,
						order_num: num
					}).then((res) => {
						if(res.code == 1) {
							clearInterval(_this.clear);
							layer.closeAll();
							layer.msg('支付成功', {
								icon: 1,
								anim: 5
							})
							_this.getData(_this.order_num)
						} else {
							if(i == 100) {
								_this.pay = true;
								clearInterval(_this.clear);
								layer.closeAll();
								layer.msg('支付超时', {
									icon: 2,
									anim: 6
								})
							}
						}
					})
				}, 3000)
			},
			getSaleCateGory() {
				let _this = this;
				api.getSaleCateGory({ //获取售后问题分类
					token: this.getCookie('token')
				}).then((res) => {
					if(res.code == 1) {
						_this.category = res.data;
						_this.forms.render();
					} else if(res.code == 0) {
						layer.msg(res.msg, {
							icon: 2,
							anim: 6
						})
					}
				});
			},
			confirmOrder() { //企业确认订单所有文件无误
				let _this = this;
				layui.use('layer', () => {
					layer.open({
						type: 0,
						content: '是否确认全部设计图已无误？确认成功后将进入下一步',
						btn: ['确定', '取消'],
						btnAlign: 'c',
						resize: false,
						closeBtn: 0,
						skin: 'demo-class',
						yes: function(index, layero) {
							layer.closeAll();
							api.confirmOrder({
								token: _this.getCookie('token'),
								order_num: _this.order_info.order_num
							}).then((res) => {
								if(res.code == 1) {
									_this.getData(_this.order_info.order_num);
								} else {
									layer.msg(res.msg, {
										icon: 2,
										anim: 6
									})
								}
							})
						},
						btn2: function(index, layero) {
							layer.closeAll();
						}
					});
				})
			},
			confirmPDF(id) { //确认PDF文件
				let _this = this;
				layui.use('layer', () => {
					layer.open({
						type: 0,
						content: '是否确认该设计图无误？',
						btn: ['确定', '设计有误'],
						btnAlign: 'c',
						resize: false,
						skin: 'demo-class',
						yes: function(index, layero) {
							layer.closeAll();
							api.confirmFile({
								token: _this.getCookie('token'),
								order_num: _this.order_info.order_num,
								order_attr_id: id,
								type: 1
							}).then((res) => {
								if(res.code == 1) {
									_this.getData(_this.order_info.order_num);
								} else {
									layer.msg(res.msg, {
										icon: 2,
										anim: 6
									})
								}
							})
						},
						btn2: function(index, layero) {
							layer.closeAll();
							_this.onError(id);
						}
					});
				})
			},
			onError(id) { //设计稿有误
				let _this = this;
				this.edit = true;
				layer.open({
					type: 1,
					title: false,
					content: $('#appeal'),
					btn: ['确认提交'],
					shade: 0,
					resize: false,
					btnAlign: 'c',
					yes: function(index, layero) {
						if(_this.text1 == '') {
							layer.msg('请输入设计图上的问题', {
								icon: 2,
								anim: 6
							})
							return false;
						}
						api.confirmFile({
							token: _this.getCookie('token'),
							order_num: _this.order_info.order_num,
							order_attr_id: id,
							type: 2,
							reason: _this.text1
						}).then((res) => {
							if(res.code == 1) {
								_this.text1 = '';
								_this.edit = false;
								layer.closeAll();
								layer.msg('提交成功', {
									icon: 1,
									anim: 5
								})
								_this.getData(_this.order_info.order_num);
							} else {
								layer.msg(res.msg, {
									icon: 2,
									anim: 6
								})
							}
						})
					},
					cancel: function() {
						_this.text1 = '';
						_this.edit = false;
						layer.closeAll();
					}
				});
			},
			cancelOrder() { //取消订单
				let _this = this;
				api.cancelOrder({
					token: this.getCookie('token'),
					order_num: this.order_info.order_num,
				}).then((res) => {
					if(res.code == 1) {
						layer.msg('取消订单成功', {
							icon: 1,
							anim: 5
						})
						_this.$router.go(-1);
					} else {
						layer.msg(res.msg, {
							icon: 2,
							anim: 6
						})
					}
				})
			},
			finishOrder(type) { //确认收货
				let _this = this;
				layui.use('layer', () => {
					if(type == 1) {
						layer.open({
							type: 0,
							content: '是否确认收货？',
							btn: ['确认', '取消'],
							btnAlign: 'c',
							resize: false,
							closeBtn: 0,
							skin: 'demo-class',
							yes: function(index, layero) {
								api.finishOrder({
									token: _this.getCookie('token'),
									order_num: _this.order_info.order_num,
								}).then((res) => {
									if(res.code == 1) {
										layer.msg('订单已完成', {
											icon: 1,
											anim: 5
										})
										_this.getData(_this.order_info.order_num);
									} else {
										layer.msg(res.msg, {
											icon: 2,
											anim: 6
										})
									}
								})
								layer.closeAll();
							},
							btn2: function(index, layero) {
								layer.closeAll();
							}
						});
					} else {
						layer.open({
							type: 0,
							content: '是否确认售后完成？',
							btn: ['确认', '取消'],
							btnAlign: 'c',
							resize: false,
							closeBtn: 0,
							skin: 'demo-class',
							yes: function(index, layero) {
								api.finishOrder({
									token: _this.getCookie('token'),
									order_num: _this.order_info.order_num,
								}).then((res) => {
									if(res.code == 1) {
										layer.msg('售后已完成', {
											icon: 1,
											anim: 5
										})
										_this.getData(_this.order_info.order_num);
									} else {
										layer.msg(res.msg, {
											icon: 2,
											anim: 6
										})
									}
								})
								layer.closeAll();
							},
							btn2: function(index, layero) {
								layer.closeAll();
							}
						});
					}
				})
			},
			afterSale() { //发起售后
				let _this = this;
				this.edit = true;
				layer.open({
					type: 1,
					title: false,
					content: $('#after'),
					shade: 0,
					resize: false,
					area: '600px',
					btnAlign: 'c',
					success: function() {
						_this.forms.render();
						_this.uploadImg();
					},
					cancel: function() {
						_this.text2 = '';
						_this.edit = false;
						$('.checkbox').prop('checked', false);
						_this.forms.render();
						_this.img = [];
						layer.closeAll();
					}
				});
			},
			uploadImg() {
				let _this = this;
				this.uploads.render({
					elem: '.upload_img', //绑定元素
					url: 'https://mr.summary88.com/api/Common/uploadFile', //上传接口
					accept: 'file',
					number: 1,
					field: 'file',
					exts: 'jpg|jpeg|png|gif',
					before: function(obj) {
						layer.load(); //上传loading
					},
					done: function(res) {
						layer.closeAll('loading');
						_this.img.push(res.image_url);
					},
					error: function(err) {
						layer.closeAll('loading');
						console.log(err) //请求异常回调
					}
				});
			},
			onEvaluate() { //评价
				let _this = this;
				this.edit = true;
				layer.open({
					type: 1,
					title: false,
					content: $('#evaluate'),
					shade: 0,
					resize: false,
					area: '1050px',
					success: function() {
						_this.uploadImg2();
					},
					cancel: function() {
						_this.edit = false;
						_this.star = [];
						_this.img2 = [];
						_this.onRateInit();
						layer.closeAll();
					}
				});
			},
			uploadImg2() {
				let _this = this;
				this.uploads.render({
					elem: '.upload_img2', //绑定元素
					url: 'https://mr.summary88.com/api/Common/uploadFile', //上传接口
					accept: 'file',
					number: 1,
					field: 'file',
					exts: 'jpg|jpeg|png|gif',
					before: function(obj) {
						layer.load(); //上传loading
					},
					done: function(res) {
						layer.closeAll('loading');
						_this.img2.push(res.image_url);
					},
					error: function(err) {
						layer.closeAll('loading');
						console.log(err) //请求异常回调
					}
				});
			},
			onRateInit() {
				let _this = this;
				this.rate.render({
					elem: '#star1',
					choose: function(value) {
						let star = value + 1;
						_this.star[0] = star;
					}
				})
				this.rate.render({
					elem: '#star2',
					choose: function(value) {
						let star = value + 1;
						_this.star[1] = star;
					}
				})
				this.rate.render({
					elem: '#star3',
					choose: function(value) {
						let star = value + 1;
						_this.star[2] = star;
					}
				})
				this.rate.render({
					elem: '#star4',
					choose: function(value) {
						let star = value + 1;
						_this.star[3] = star;
					}
				})
				this.rate.render({
					elem: '#star5',
					choose: function(value) {
						let star = value + 1;
						_this.star[4] = star;
					}
				})
				this.rate.render({
					elem: '#star6',
					choose: function(value) {
						let star = value + 1;
						_this.star[5] = star;
					}
				})
				this.rate.render({
					elem: '#star7',
					choose: function(value) {
						let star = value + 1;
						_this.star[6] = star;
					}
				})
				this.rate.render({
					elem: '#star8',
					choose: function(value) {
						let star = value + 1;
						_this.star[7] = star;
					}
				})
				this.rate.render({
					elem: '#star9',
					choose: function(value) {
						let star = value + 1;
						_this.star[8] = star;
					}
				})
				this.rate.render({
					elem: '#star10',
					choose: function(value) {
						let star = value + 1;
						_this.star[9] = star;
					}
				})
			},
			orderProgress(progress, status) {
				let _this = this;
				let obj = [];
				if(progress.createtime) {
					obj.push({
						title: '下单',
						time: progress.createtime,
						time_txt: this.getTimes(progress.createtime),
					})
				}
				if(progress.c_pay_order_time) {
					obj[0] = {
						title: '下单',
						time: progress.c_pay_order_time,
						time_txt: this.getTimes(progress.c_pay_order_time),
					}
				}
				if(progress.c_cancel_order_time) {
					obj.push({
						title: '取消订单',
						time: progress.c_cancel_order_time,
						time_txt: this.getTimes(progress.c_cancel_order_time),
					})
				}
				if(progress.e_get_order_time) {
					obj.push({
						title: '工程师接单',
						time: progress.e_get_order_time,
						time_txt: this.getTimes(progress.e_get_order_time),
					})
				}
				if(progress.e_finish_order_time) {
					obj.push({
						title: '工程师完工',
						time: progress.e_finish_order_time,
						time_txt: this.getTimes(progress.e_finish_order_time),
					})
				}
				if(progress.f_get_order_time) {
					obj.push({
						title: '工厂接单',
						time: progress.f_get_order_time,
						time_txt: this.getTimes(progress.f_get_order_time),
					})
				}
				if(progress.f_finish_order_time) {
					obj.push({
						title: '已发货',
						time: progress.f_finish_order_time,
						time_txt: this.getTimes(progress.f_finish_order_time),
					})
				}
				if(progress.f_rep_order_time) {
					obj.push({
						title: '补发',
						time: progress.f_rep_order_time,
						time_txt: this.getTimes(progress.f_rep_order_time),
					})
				}
				if(progress.c_post_sale_time) {
					obj.push({
						title: '客户发起售后',
						time: progress.c_post_sale_time,
						time_txt: this.getTimes(progress.c_post_sale_time),
						color: '#E51C23'
					})
				}
				if(progress.a_get_order_time) {
					obj.push({
						title: '平台客服接入',
						time: progress.a_get_order_time,
						time_txt: this.getTimes(progress.a_get_order_time),
						color: '#1890FF'
					})
				}
				if(progress.e_rework_time) {
					obj.push({
						title: '工程师返工',
						time: progress.e_rework_time,
						time_txt: this.getTimes(progress.e_rework_time),
						color: '#FF9800'
					})
				}
				if(progress.e_rework_finish_time) {
					obj.push({
						title: '工程师返工完成',
						time: progress.e_rework_finish_time,
						time_txt: this.getTimes(progress.e_rework_finish_time),
					})
				}
				if(progress.f_rework_time || progress.f_rework_finish_time) {
					obj.push({
						title: '工厂重新发货',
						time: progress.f_rework_finish_time ? progress.f_rework_finish_time : progress.f_rework_time,
						time_txt: this.getTimes(progress.f_rework_finish_time ? progress.f_rework_finish_time : progress.f_rework_time),
					})
				}
				if(progress.c_finish_order_time) {
					obj.push({
						title: '订单完成',
						time: progress.c_finish_order_time,
						time_txt: this.getTimes(progress.c_finish_order_time),
					})
				}
				this.order_progress = obj;
				if(status == 2 && this.order_info.sales_status != 1 && this.order_info.sales_status != 2) {
					let obj2 = [];
					obj2.push({
						title: '预估工程师接单',
						time: '',
						time_txt: progress.e_wait_time_text,
					})
					obj2.push({
						title: '预估工程师完成',
						time: '',
						time_txt: progress.e_finish_time_text,
					})
					obj2.push({
						title: '预估工厂接单',
						time: '',
						time_txt: progress.f_wait_time_text,
					})
					obj2.push({
						title: '预估工厂发货',
						time: '',
						time_txt: progress.f_finish_time,
					})
					this.estimate = obj2;
					this.ct = '';
					clearInterval(this.ct);
					let time = new Date(progress.e_wait_time_text).getTime();
					this.ct = setInterval(() => {
						_this.getCountDown(time / 1000, status);
					}, 1000)
				} else if(status == 3 && this.order_info.sales_status != 1 && this.order_info.sales_status != 2) {
					let obj2 = [];
					obj2.push({
						title: '预估工程师完成',
						time: '',
						time_txt: progress.e_finish_time_text,
					})
					obj2.push({
						title: '预估工厂接单',
						time: '',
						time_txt: progress.f_wait_time_text,
					})
					obj2.push({
						title: '预估工厂发货',
						time: '',
						time_txt: progress.f_finish_time,
					})
					this.estimate = obj2;
					this.ct = '';
					clearInterval(this.ct);
					let time = new Date(progress.e_finish_time_text).getTime();
					this.ct = setInterval(() => {
						_this.getCountDown(time / 1000, status);
					}, 1000)
				} else if(status == 4 && this.order_info.sales_status != 1 && this.order_info.sales_status != 2 && this.timeline.is_c_confirm == 3) {
					let obj2 = [];
					obj2.push({
						title: '预计工程师修改完成',
						time: progress.e_finish_order_time + 60 * 120,
						time_txt: this.getTimes(progress.e_finish_order_time + 60 * 120),
					})
					this.estimate = obj2;
					this.ct = '';
					clearInterval(this.ct);
					this.ct = setInterval(() => {
						_this.getCountDown(progress.e_finish_order_time + 60 * 120, status);
					}, 1000)
				} else if(status == 5 && this.order_info.sales_status != 1 && this.order_info.sales_status != 2) {
					let obj2 = [];
					obj2.push({
						title: '预估工厂接单',
						time: '',
						time_txt: progress.f_wait_time_text,
					})
					obj2.push({
						title: '预估工厂发货',
						time: '',
						time_txt: progress.f_finish_time,
					})
					this.estimate = obj2;
					this.ct = '';
					clearInterval(this.ct);
					let time = new Date(progress.f_wait_time_text).getTime();
					this.ct = setInterval(() => {
						_this.getCountDown(time / 1000, status);
					}, 1000)
				} else if(status == 6 && this.order_info.sales_status != 1 && this.order_info.sales_status != 2) {
					let obj2 = [];
					obj2.push({
						title: '预估工厂发货',
						time: '',
						time_txt: progress.f_finish_time,
					})
					this.estimate = obj2;
					this.ct = '';
					clearInterval(this.ct);
					let time = new Date(progress.f_finish_time).getTime();
					this.ct = setInterval(() => {
						_this.getCountDown(time / 1000, status);
					}, 1000)
				}
			},
			getCountDown(time, status) { //倒计时
				let _this = this;
				let t = time * 1000 - new Date().getTime();
				if(t < 0) {
					clearInterval(this.ct);
					this.overtime = 1;
					if(status && (status == 2 || status == 5)) {
						this.overtimeOrder();
					}
				} else {
					let hh = parseInt(t / (60 * 60 * 1000));
					t = t % (60 * 60 * 1000);
					let mm = parseInt(t / (60 * 1000));
					t = t % (60 * 1000);
					let ss = parseInt(t / (1000));
					hh = hh < 10 ? '0' + hh : hh;
					mm = mm < 10 ? '0' + mm : mm;
					ss = ss < 10 ? '0' + ss : ss;
					this.count_down = hh + ':' + mm + ':' + ss;
				}
			},
			overtimeOrder() {
				api.overtimeOrder({
					order_num: this.order_num
				}).then((res) => {
					console.log('订单超时');
				})
			},
			onCancelImage(i) { //删除订单评价图片
				this.img2.splice(i, 1);
			},
			onGouTong() {
				this.$router.push({
					path: '/communicate',
					query: {
						order_num: this.order_num,
						id: this.order_info.order_id
					}
				})
			},
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	#qrCode {
		width: 300px;
		padding: 20px 20px 50px;
	}
	
	#qrCode img {
		display: block;
		width: 300px;
		height: 300px;
		margin-bottom: 30px;
	}
	
	#qrCode p {
		font-size: 16px;
		text-align: center;
	}
	
	.goutong2 {
		padding: 4px 8px;
		border: 1px solid #666;
		border-radius: 15px;
		margin-top: -5px;
		cursor: no-drop;
	}
	
	.checkbox_box .layui-form-radio {
		width: auto !important;
	}
	
	.msg {
		margin-right: 15px;
		color: #3c3c3c;
		font-size: 16px;
		line-height: 30px;
	}
	
	.addressInfo {
		display: flex;
	}
	
	.address {
		flex: 1;
		display: flex;
		align-items: center;
	}
	
	.linkman {
		flex: 1;
		display: flex;
		align-items: center;
	}
	
	.otherBtn {
		background: #4876FF !important;
	}
	
	.file-list {
		min-height: 25px;
		margin-bottom: 20px;
		padding-left: 20px;
	}
	
	.file-list:last-child {
		margin-bottom: 0;
	}
	
	.file-list .file-item {
		/*display: flex;*/
	}
	
	.progress ul li:last-child {
		padding-bottom: 0 !important;
	}
	
	.goutong {
		padding: 4px 8px;
		border: 1px solid;
		border-radius: 15px;
		margin-top: -5px;
	}
	
	.btn1 {
		background: rgb(139, 195, 74);
	}
	
	.btn2 {
		background: rgb(255, 152, 0);
	}
	
	.btn3 {
		background: rgb(112, 112, 112);
	}
	
	.count_down {
		color: rgba(255, 152, 0, 1);
		display: flex;
		align-items: center;
	}
	
	.count_down span {
		margin-left: 10px;
		font-size: 18px;
	}
	
	.count_down .layui-icon {
		font-size: 24px;
		margin-left: 20px;
		color: rgba(255, 152, 0, 1);
	}
	
	.pay {
		display: block;
		width: 400px;
		height: 45px;
		color: rgb(255, 255, 255);
		background-color: rgb(229, 28, 35);
		border-radius: 0px;
		font-size: 20px;
		text-align: center;
		margin: 50px auto;
		cursor: pointer;
	}
	
	.shopCar {
		font-family: SourceHanSansSC;
	}
	
	.sxBox {
		padding: 20px 10% 10px;
	}
	
	.scektsBox {
		position: absolute;
		bottom: 0;
		right: 0;
		width: 100%;
	}
	
	.courier {
		padding: 8px 30px;
		line-height: 50px;
		height: 50px;
		font-size: 18px;
		border-bottom: 1px solid #e6e6e6;
		display: flex;
		align-items: center;
	}
	
	.courier span {
		margin-left: 30px;
	}
	
	.courier:last-child {
		border-bottom: none;
	}
	
	.courier .sel_kd {
		display: flex;
	}
	
	.courier .sel_kd div {
		margin-left: 20px;
	}
	
	.status_text {
		color: rgba(255, 152, 0, 1);
	}
	
	#status15 {
		color: #000000;
	}
	
	.status p span {
		margin-left: 10px;
	}
	
	.cancel,
	.afterSale {
		background-color: rgb(63, 81, 181);
	}
	
	.add_price,
	.delivery {
		background-color: rgba(37, 155, 36, 1);
	}
	
	.delivery-false {
		color: #8D8D8D;
		background-color: #E2E2E2;
	}
	
	.links {
		color: rgb(72, 118, 255) !important;
		margin-right: 15px;
		text-decoration: underline;
	}
	
	.layer {
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, 0.3);
		z-index: 10000;
	}
	
	#appeal {
		width: 300px;
		padding: 0 20px;
	}
	
	#appeal .title {
		font-size: 20px;
		font-weight: bold;
		text-align: center;
		line-height: 50px;
	}
	
	#appeal textarea {
		width: 100% !important;
		border: 1px solid #C9C9C9;
		border-radius: 5px;
		font-size: 14px;
		height: 150px !important;
		resize: none;
		box-sizing: border-box;
		padding: 5px;
	}
	
	#after {
		width: 560px;
		padding: 0 20px 30px;
	}
	
	#after .title {
		font-size: 20px;
		font-weight: bold;
		text-align: center;
		line-height: 50px;
	}
	
	#after p {
		line-height: 30px;
	}
	
	#after .checkbox_box {
		display: flex;
		flex-direction: column;
	}
	
	#after textarea {
		width: 100% !important;
		border: 1px solid #C9C9C9;
		border-radius: 5px;
		font-size: 14px;
		height: 150px !important;
		resize: none;
		box-sizing: border-box;
		padding: 5px;
	}
	
	.layui-form-item .preview {
		width: 120px;
		height: 120px;
		margin-right: 20px;
		margin-bottom: 20px;
	}
	
	.layui-form-item .preview:nth-child(4n) {
		margin-right: 0;
	}
	
	.upload_img {
		width: 120px;
		height: 120px;
		margin-bottom: 20px;
	}
	
	#evaluate {
		padding: 0 20px 30px;
	}
	
	#evaluate .title {
		font-size: 20px;
		font-weight: bold;
		text-align: center;
		line-height: 50px;
	}
	
	#evaluate .layui-form {
		display: flex;
		flex-wrap: wrap;
	}
	
	#evaluate .layui-form-item {
		width: 330px;
		margin-bottom: 0;
	}
	
	#evaluate .layui-form-item h3 {
		line-height: 50px;
	}
	
	#evaluate .layui-form-item .star_total {
		display: flex;
		align-items: center;
	}
	
	#evaluate .layui-form-item .star_box .star_list {
		display: flex;
		align-items: center;
	}
	
	#evaluate .layui-form-item .label {
		width: 100px;
		text-align: right;
	}
	
	#evaluate .layui-form-item .tit {
		line-height: 50px;
	}
	
	#evaluate textarea {
		width: 100% !important;
		border: 1px solid #C9C9C9;
		border-radius: 5px;
		font-size: 14px;
		height: 150px !important;
		resize: none;
		box-sizing: border-box;
		padding: 5px;
	}
	
	.preview_box {
		float: left;
		position: relative;
		border-radius: 5px;
		overflow: hidden;
		margin-right: 15px;
		margin-bottom: 30px;
	}
	
	.preview_box .cancel_btn {
		width: 20px;
		height: 20px;
		position: absolute;
		top: 0;
		right: 0;
		z-index: 10;
		cursor: pointer;
	}
	
	.layui-form-item .preview2 {
		width: 110px;
		height: 110px;
		/*margin-right: 15px;
		margin-bottom: 30px;*/
	}
	
	.upload_img2 {
		width: 110px;
		height: 110px;
		margin-bottom: 30px;
	}
	
	#star1,
	#star2,
	#star3,
	#star4,
	#star5,
	#star6,
	#star7,
	#star8,
	#star9,
	#star10 {
		position: relative;
		top: 7px;
		margin-left: 10px;
	}
	
	.title {
		padding: 8px 30px;
		color: #fff;
		border-radius: 5px;
	}
	
	.downloadBtn {
		width: 46px;
		height: 26px;
		line-height: 26px;
		font-size: 12px;
		background: #4876FF;
		color: #FFFFFF;
		display: inline-block;
		text-align: center;
		border-radius: 3px;
		margin-left: 5px;
	}
</style>


// WEBPACK FOOTER //
// src/components/orderDetail.vue